export function checkInput(evt) {
  const submitButton = evt.currentTarget.closest('form').querySelector('button[type="submit"]');
  if (evt.currentTarget.value.length === 0) {
    submitButton.disabled = true;
    return;
  }
  submitButton.disabled = false;
}
